import ajax from "../assets/uilt/ajax";

let bankTransfer = {
  //add new inter bank transfer
  addInterBankTransfer: req => {
    return ajax.post({
      url: "/back/bank-transfer/add-bank-transfer",
      param: req.param,
      success: req.success
    });
  },

  //  edit inter bank transfer
  updateInterBankTransfer: req => {
    return ajax.post({
      url: "/back/bank-transfer/update-bank-transfer",
      param: req.param,
      success: req.success
    });
  },

  // get inter bank transfer page
  getInterBankTransferPage: req => {
    return ajax.get({
      url: "/back/bank-transfer/get-inter-bank-transfer-page",
      param: req.param,
      success: req.success
    });
  },
  // check inter bank transfer
  checkInterBankTransfer: req => {
    return ajax.post({
      url: "/back/bank-transfer/check-inter-bank-transfer",
      param: req.param,
      success: req.success
    });
  }

  //
};

export default bankTransfer;
